import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { KeyPersonsService } from '../../services/key-persons.service';

@Component({
  selector: 'app-update-key-persons',
  templateUrl: './update-key-persons.component.html',
  styleUrls: ['./update-key-persons.component.css']
})
export class UpdateKeyPersonsComponent implements OnInit, OnDestroy {

  id: string;
  parent: string;
  customerOrSupplier: string;

  keyPersonForm: FormGroup;
	keyPerson$: Observable<any>;

	keyPersonSub: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private keyPersonsService: KeyPersonsService
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
    this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];

    this.keyPerson$ = this.keyPersonsService.getKeyPerson(this.id);
    this.keyPersonSub = this.keyPerson$.subscribe(data => {
			const formData = {
        name: data.name,
        lastName: data.lastName,
        job: data.job,
        phone: data.phone,
        email: data.email
			};
			this.keyPersonForm = this.formBuilder.group(formData);
		});
  }

  ngOnInit() {
		this.keyPersonForm = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: [''],
      job: [''],
      phone: [''],
      email: ['', Validators.email],
		});
  }
  ngOnDestroy() {
    this.keyPersonSub.unsubscribe();
  }
  onSubmitKeyPerson({value, validate}: any) {
		this.keyPersonsService.updateKeyPerson(this.id, value);
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/keyPersons']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/keyPersons']);
		}
  }
  getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/keyPersons']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/keyPersons']);
		}
	}

}
